module.exports = __webpack_public_path__ + "img/icon_T_And_S.fcaeb51f.jpg";